import { render } from "./Checkout.vue?vue&type=template&id=dc454d5c&scoped=true"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import "./Checkout.vue?vue&type=style&index=0&id=dc454d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc454d5c"]])

export default __exports__